<template>
  <div class="pa-4">
    <div v-if="idea">
      <div class="cal-sans-regular font-size-24">{{ idea.title || idea.name || 'Untitled Idea' }}</div>
      <div class="mt-2">{{ idea.description || 'No description yet.' }}</div>
    </div>
    <div v-else class="grey--text">
      Start by telling Sparky what you want to create. Your idea summary will appear here.
    </div>
  </div>
</template>

<script>
export default {
  name: 'IdeaPreview',
  props: { idea: { type: Object, default: null } }
}
</script>


